import { ISelfSignupService } from "../../core/impl/selfSignupServiceImpl";

export type ISelfSignupController = ReturnType<typeof SelfSignupControllerFactory>;

export const SelfSignupControllerFactory = ({
  selfSignupService,
}: {
  selfSignupService: ISelfSignupService;
}) => {
  /**
   * Register the newly confirmed Cognito user in the backend.
   * Returns { user_id, activation_state: "pending_activation" } on success.
   */
  const registerPendingUser = async (payload: {
    first_name?: string;
    last_name?: string;
    phone?: string;
  }): Promise<IControllerPromiseResponse<{ user_id: string; activation_state: string }>> => {
    try {
      const data = await selfSignupService.registerPendingUser(payload);
      return { success: true, data };
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : "Failed to register account.";
      return { success: false, error: { message } };
    }
  };

  /**
   * Poll to check whether care-team approval has been granted.
   * Returns { activation_state: "pending_activation" | "active" }.
   * The PendingActivation page calls this every 30 s.
   */
  const checkActivationStatus = async (): Promise<
    IControllerPromiseResponse<{
      user_id: string;
      activation_state: "pending_activation" | "active";
    }>
  > => {
    try {
      const data = await selfSignupService.checkActivationStatus();
      return { success: true, data };
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : "Failed to check activation status.";
      return { success: false, error: { message } };
    }
  };

  return {
    registerPendingUser,
    checkActivationStatus,
  };
};
